exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btnEvidencia {\n  padding: 0px;\n  margin: 6px 0px;\n}\n", ""]);

// exports
